<template>
  <BLabel
    round
    class="lead-source-preview"
  >
    <span
      class="lead-source-preview-text"
      :title="leadSource.name"
    >{{ leadSource.name }}</span>
  </BLabel>
</template>

<script lang="ts" setup>
import type { LeadSource } from '@/api/openapi';

type TProps = {
  leadSource: LeadSource;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
.lead-source-preview {
  max-width: 100%;

  .lead-source-preview-text {
    @include m-truncate-text;
    width: 100%;
  }
}
</style>
